module.exports = __webpack_public_path__ + "img/pdf.29cc0c31.svg";